import React, { FC, ReactElement, useRef, useState } from 'react'
import { createRoot } from 'react-dom/client'
import { StyleSheetManager } from 'styled-components'
import MainComponent from 'components/MainComponent'

const App: FC<MicroFrontendProps> = (microFrontendProps): ReactElement => {
  const [ref, setRef] = useState<HTMLDivElement | null>()
  const styleRef = useRef<any>()
  const [cssIsInjected, setCssIsInjected] = useState(false)

  if (styleRef.current) {
    styleRef.current.onload = () => {
      setCssIsInjected(true)
    }
    styleRef.current.onerror = () => {
      // if we don't have any css file (if you use styled components) 
      setCssIsInjected(true)
    }
  }

  return (
    <div id='root' ref={(newRef) => setRef(newRef)}>
      <link
        ref={styleRef}
        rel='stylesheet'
        href={(process.env.REACT_APP_DEPLOY_PATH ? (process.env.REACT_APP_DEPLOY_PATH + '/static/css/main.css') : "static/css/main.css")}
      />
      {ref && cssIsInjected && (
        <div id='app'>
          <StyleSheetManager target={ref}>
            <MainComponent {...microFrontendProps} />
          </StyleSheetManager>
        </div>
      )}
    </div>
  )
}
export default App
if (window.document.title === 'TA-Interaktiv Microfrontend') {
  const DevToolAppWrapper: FC = (): ReactElement => {
    const [isDarkmode, setIsDarkmode] = useState(false)
    const [showDevTools, setShowDevTools] = useState(false)

    return (
      <>
        <div id='dev-tools-container'>
          <div onClick={() => setShowDevTools(!showDevTools)}>
            Toggle Devtools
          </div>
          {showDevTools && (
            <div>
              <div>
                <span>Darkmode:</span>
                <input
                  type='button'
                  value={isDarkmode ? 'on' : 'off'}
                  onClick={() => setIsDarkmode(!isDarkmode)}
                />
              </div>
              {process.env.REACT_APP_DEPLOY_PATH &&
                <a
                  onClick={(e) => {
                    e.preventDefault()
                    navigator.clipboard.writeText(
                      process.env.REACT_APP_DEPLOY_PATH + '/static/js/main.js'
                    )
                  }}
                  href={
                    process.env.REACT_APP_DEPLOY_PATH + '/static/js/main.js'
                  }
                >
                  Copy path to JS 🔗
                </a>
              }
            </div>
          )}
        </div>

        <App
          tenant={{
            domain: 'tagesanzeiger',
            feedId: 2,
            key: 'tagesanzeiger',
            lang: 'de',
            name: 'Tages-Anzeiger',
          }}
          colorMode={isDarkmode ? 'dark' : 'light'}
          properties={{fallbackContent:"aaa"}}
        />
      </>
    )
  }

  const root = createRoot(document.getElementById('root')!)
  root.render(
    <React.StrictMode>
      <DevToolAppWrapper />
    </React.StrictMode>
  )
}
